import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '../../utils';
import { CustomIconMap, CustomIconName } from '../generated/svg';

const iconVariants = cva(
  `
  `,
  {
    variants: {
      size: {
        xs: 'text-xs',
        sm: 'text-sm',
        md: 'text-md',
        lg: 'text-lg',
        xl: 'text-xl',
        '2xl': 'text-2xl',
        '3xl': 'text-3xl',
        '4xl': 'text-4xl',
        '5xl': 'text-5xl',
        '6xl': 'text-6xl',
        '7xl': 'text-7xl'
      }
    },
    defaultVariants: {
      size: 'md'
    }
  }
);

type IconVariants = VariantProps<typeof iconVariants>;

export interface CustomIconProps extends IconVariants {
  name: CustomIconName;
  className?: string;
}

export const CustomIcon = (props: CustomIconProps) => {
  const { name, className, size, ...other } = props;

  const Cmp = CustomIconMap[name];
  return <Cmp className={cn(iconVariants({ className, size }))} {...other} />;
};
